import {
  GET_QUOTATIONS,
  QUOTATIONS_RECEIVED,
  SEARCH_QUOTATIONS,
  FILTERS_RECEIVED,
  UPDATE_SORT,
  REMOVE_ALL,
  REMOVE_FILTER,
  LOAD_FILTERS,
  SET_PAGE_NUMBER,
  DOWNLOAD_QUOTATIONS,
} from './constants';

/**
 *
 * @returns {{type: *}}
 */
export const getQuotations = () => ({
  type: GET_QUOTATIONS,
});

/**
 *
 * @param quotations
 * @param total
 * @param lastPage
 * @param currentPage
 * @returns {{total: *, lastPage: *, quotations: *, type: *, currentPage: *}}
 */
export function quotationsLoaded(quotations, total, lastPage, currentPage) {
  return {
    type: QUOTATIONS_RECEIVED,
    quotations,
    total,
    lastPage,
    currentPage,
  };
}

/**
 *
 * @param parameters
 * @returns {{query: *, type: *}}
 */
export function searchQuotations(parameters) {
  return {
    type: SEARCH_QUOTATIONS,
    parameters,
  };
}

/**
 *
 * @returns {{type: *}}
 */
export const loadFilters = () => ({
  type: LOAD_FILTERS,
});

/**
 *
 * @param filters
 * @returns {{filters: *, type: string}}
 */
export const filtersLoaded = filters => ({
  type: FILTERS_RECEIVED,
  filters,
});

/**
 *
 * @returns {{type: string}}
 */
export const removeAll = () => ({
  type: REMOVE_ALL,
});

/**
 *
 * @returns {{type: string}}
 */
export const removeFilter = filterName => ({
  type: REMOVE_FILTER,
  filterName,
});

/**
 *
 * @param sort
 * @returns {{type: string, sort: string}}
 */
export function orderBy(order) {
  return {
    type: UPDATE_SORT,
    order,
  };
}

/**
 *
 * @param pageNumber
 * @returns {{page: *, type: *}}
 */
export function setPage(pageNumber) {
  return {
    type: SET_PAGE_NUMBER,
    pageNumber,
  };
}

/**
 */
export function downloadQuotations() {
  return {
    type: DOWNLOAD_QUOTATIONS,
  };
}
